import i18next from 'i18next';
import opportunities from '@/constants/opportunities';

/**
 * Compares the time with the starting time. Will return an error string if time is behind
 * the start time.
 * @param {getTimeStart} a function that returns the thunk starting time. So we guarantee the latest value from the form.
 * @param {value} the time
 */
export const afterStartTime = (getTimeStart) => (value) => {
    if (typeof getTimeStart !== 'function') return null;

    const timeStart = getTimeStart?.();
    if (!timeStart || !value) return null;

    return value <= timeStart ? i18next.t("Enter an end time that's later than your start time") : null;
};

export const withinBusinessHours = (min, max) => (value) => {
    if (!value) return null;
    return value < min || value > max ? i18next.t('Enter a time between %(min)s and %(max)s', { min, max }) : null;
};

export const withinRecommendedLeadTime = () => (date) => {
    if (!date) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const recommended = new Date(today);

    recommended.setDate(recommended.getDate() + opportunities.MIN_LEAD_DAYS_FOR_WARNING);

    return new Date(date).getTime() < recommended.getTime()
        ? i18next.t('Please review your date selection. We recommend at least 10 days lead time for your request.')
        : null;
};

export const dateAndTimeInFuture = (getTimeStart, getDate) => () => {
    if (typeof getTimeStart !== 'function' || typeof getDate !== 'function') return null;

    const timeStart = getTimeStart?.();
    const date = getDate?.();
    if (!timeStart || !date) return null;

    const proposedTimestamp = new Date(date);

    const [hours, minutes] = timeStart.split(':');
    proposedTimestamp.setHours(hours);
    proposedTimestamp.setMinutes(minutes);

    const timestampInFuture = proposedTimestamp > new Date();
    if (timestampInFuture) return null;
    return i18next.t('Change your date and start time to be in the future.');
};
